module.exports = __webpack_public_path__ + "img/page-29.f8213963.jpg";